<div
    class="sb-modal-grid"
    [class.sb-modal-aside-right]="(viewPortSize$ | async) !== 'xs'"
    *ngIf="showFilters"
    [@fadeInOutModal]
>
    <section
        role="dialog"
        aria-modal="true"
        aria-label="Add or update data"
        class="sb-modal-grid-container sb-modal-xs"
    >
        <header class="sb-modal-grid-header">
            <h2 class="mb-0">Settings</h2>
        </header>
        <main class="sb-modal-grid-body">
            <div class="row gy-3" *ngIf="showFilters" @fadeInOut>
                <div class="col-6">
                    <h4 class="mb-2">Search</h4>
                    <form [formGroup]="filterForm">
                        <mat-form-field appearance="fill">
                            <mat-label>Search</mat-label>
                            <input matInput formControlName="search" autocomplete="off" />
                            <tabler-icon name="search" matSuffix></tabler-icon>
                            <mat-hint>Type to filter accounts</mat-hint>
                        </mat-form-field>
                    </form>
                </div>
                <div class="col-6">
                    <h4 class="mb-2">Sort</h4>
                    <form *ngIf="showFilters" @fadeInOut [formGroup]="sortForm">
                        <div class="d-flex align-items-start">
                            <mat-form-field appearance="fill" style="min-width: 0">
                                <mat-label>Sort on</mat-label>
                                <mat-select formControlName="sortBy">
                                    <mat-option
                                        *ngFor="let option of sortByOptions"
                                        [value]="option.key"
                                    >
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>How to sort accounts</mat-hint>
                            </mat-form-field>
                            <button
                                class="btn btn-sm primary btn-square m-2 me-md-0 pt-2 flex-shrink-0"
                                type="button"
                                [matTooltip]="
                                    (sortForm.value.sortByOrder !== 'asc'
                                        ? 'Click to sort accounts ascending'
                                        : 'Click to sort accounts descending') +
                                    ' by ' +
                                    sortForm.value.sortBy
                                "
                                (click)="toggleSortOrder()"
                            >
                                <tabler-icon
                                    class="sb-icon"
                                    [name]="
                                        sortForm.value.sortByOrder === 'asc'
                                            ? 'sort-ascending'
                                            : 'sort-descending'
                                    "
                                ></tabler-icon>
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by account type</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableAccountTypes$ | async"
                        (badgesChange)="filterAccountTypes($event)"
                    ></sb-badges>
                    <!--<sb-badges
                        *ngIf="tags$ | async as tags"
                        size="sm"
                        allowActive="multiple"
                        wrap="true"
                        (badgesChange)="filterTags($event)"
                        [badges]="tags"
                    ></sb-badges>-->
                </div>
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by issuer</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableIssuers$ | async"
                        (badgesChange)="filterIssuers($event)"
                    ></sb-badges>
                </div>
                <!--
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by legal entity</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableLegalEntities$ | async"
                        (badgesChange)="filterLegalEntities($event)"
                    ></sb-badges>
                </div>-->
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by instrument (BETA)</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableInstruments$ | async"
                        (badgesChange)="filterInstruments($event)"
                    ></sb-badges>
                </div>
                <!--<div class="col-6 ps-3 ps-sm-2">
                    <h4 class="mb-2">View</h4>
                    <mat-form-field appearance="fill">
                        <mat-label>Account view</mat-label>
                        <mat-select [formControl]="viewCtrl">
                            <mat-option
                                *ngFor="let option of viewOptions"
                                [value]="option.value"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                        <mat-hint>How to display accounts</mat-hint>
                    </mat-form-field>
                </div>-->
            </div>
        </main>
        <footer
            class="sb-modal-grid-footer row gy-3 align-items-center text-center text-sm-right"
        >
            <div class="col-12">
                <button type="button" class="btn secondary" (click)="toggleShowFilters()">
                    Hide settings
                </button>
                <!--<button
                    type="button"
                    class="btn primary"
                    (click)="saveSettings()"
                    [disabled]="filterForm.pristine"
                >
                    Save and close
                </button>-->
            </div>
        </footer>
    </section>
    <!--<div class="backdrop" (click)="toggleShowFilters()"></div>-->
</div>
<div [class.container-fluid]="isStandalone" [class.sb-standalone-mode]="isStandalone">
    <section
        class="card"
        [class.sb-highlight-content]="(viewPortSize$ | async) !== 'xs' && showFilters"
    >
        <header class="card-header align-items-center mt-n2">
            <h3 class="mb-0">
                Holdings per
                <sb-generic-type-select
                    class="d-inline-block my-n3"
                    [formControl]="groupByCtrl"
                    appearance="none"
                    [valueKey]="false"
                    [options]="groupByOptions"
                ></sb-generic-type-select>
                <!--{{ groupByCtrl.value.name | lowercase }}-->
            </h3>
            <div>
                <button
                    type="button"
                    class="btn btn-link me-n3 text-primary"
                    (click)="toggleShowFilters()"
                >
                    <tabler-icon name="adjustments-horizontal"></tabler-icon>
                    <sb-notification-badge
                        *ngIf="
                            (filterForm.value.type
                                | sbFilterCount
                                    : (availableAccountTypes$ | async)
                                    : (isLoading$ | async)) +
                            (filterForm.value.tags
                                | sbFilterCount
                                    : (tags$ | async)
                                    : (isLoading$ | async)) +
                            (legalEntitiesCtrl.value
                                | sbFilterCount
                                    : (availableLegalEntities$ | async)
                                    : (isLoading$ | async)) +
                            (issuersCtrl.value
                                | sbFilterCount
                                    : (availableIssuers$ | async)
                                    : (isLoading$ | async)) +
                            (instrumentsCtrl.value
                                | sbFilterCount
                                    : (availableInstrumentIds$ | async)
                                    : (isLoading$ | async)) as numberOfFilters
                        "
                        [@fadeInOut]
                        [tooltip]="
                            numberOfFilters === 1
                                ? 'A filter has been applied to the list.'
                                : numberOfFilters +
                                  ' filters have been applied to the list.'
                        "
                        [numberOfNotifications]="numberOfFilters"
                        iconBadge="true"
                    ></sb-notification-badge>
                </button>
                <!--<button
                    type="button"
                    class="btn btn-link m-n3 text-primary"
                    [matMenuTriggerFor]="equityListContextMenu"
                >
                    <tabler-icon name="dots"></tabler-icon>
                </button>-->
            </div>
            <mat-menu #equityListContextMenu="matMenu">
                <button
                    type="button"
                    class="d-flex align-items-center"
                    mat-menu-item
                    (click)="toggleShowFilters()"
                >
                    <tabler-icon
                        class="sb-icon-md me-2"
                        name="adjustments-horizontal"
                    ></tabler-icon>
                    {{ showFilters ? 'Hide' : 'Show' }} filters
                </button>
                <button type="button" class="d-flex align-items-center" mat-menu-item>
                    <tabler-icon
                        class="sb-icon-md me-2"
                        name="file-type-csv"
                    ></tabler-icon>
                    Export as CSV
                </button>
                <button type="button" class="d-flex align-items-center" mat-menu-item>
                    <tabler-icon
                        class="sb-icon-md me-2"
                        name="file-type-xls"
                    ></tabler-icon>
                    Export as Excel
                </button>
                <button
                    type="button"
                    class="d-inline-flex align-items-center"
                    mat-menu-item
                >
                    <tabler-icon
                        class="me-2"
                        style="height: 20px; width: 20px; display: inline-flex"
                        [name]="true ? 'error-404-off' : '123'"
                    ></tabler-icon>
                    {{ true ? 'Use regular numbers' : 'Use short numbers' }}
                </button>
                <button
                    type="button"
                    class="d-inline-flex align-items-center"
                    mat-menu-item
                    (click)="toggleCurrencyDisplay()"
                >
                    <tabler-icon
                        class="me-2"
                        style="height: 20px; width: 20px; display: inline-flex"
                        [name]="(useBaseCurrency$ | async) ? 'coin-off' : 'coin'"
                    ></tabler-icon>
                    {{
                        (useBaseCurrency$ | async)
                            ? 'Use account currency'
                            : 'Use base currency'
                    }}
                </button>
            </mat-menu>
        </header>
        <div class="mt-3 px-3 px-sm-4" [@fadeInOut] *ngIf="viewCtrl.value === 'detailed'">
            <div class="group justify-content-center justify-content-sm-end">
                <button
                    *ngFor="let option of periods"
                    class="btn btn-sm secondary"
                    role="option"
                    [class.active]="(period$ | async).name === option.name"
                    [attr.aria-selected]="(period$ | async).name === option.name || null"
                    (click)="setPeriod(option)"
                >
                    <tabler-icon
                        name="calendar"
                        *ngIf="option.name === 'Custom'"
                        style="height: 16px; width: 16px"
                        class="my-n2 me-1"
                    ></tabler-icon>
                    <span [class.visually-hidden]="option.name === 'Custom'">
                        {{ option.name }}
                    </span>
                </button>
            </div>
        </div>
        <div class="card-body pt-2 overflow-hidden" *ngIf="accounts$ | async as data">
            <ng-container
                *ngIf="data.accounts && data.accounts.length > 0; else noAccounts"
            >
                <dl
                    class="sb-account-list"
                    [class.sb-account-list-condensed]="viewCtrl.value === 'condensed'"
                    [class.sb-account-list-minimal]="viewCtrl.value === 'minimal'"
                    [@list]="currentPage$ | async"
                    (@list.start)="onAnimationStart($event)"
                    (@list.done)="onAnimationDone($event)"
                >
                    <ng-container
                        *ngFor="
                            let account of data.accounts;
                            trackBy: trackByFn;
                            let i = index
                        "
                    >
                        <div
                            @slideInOut
                            class="sb-account"
                            [class.sb-account-first]="i === 0"
                            [style.--item-index]="i + 1"
                        >
                            <div class="sb-account-logo">
                                <sb-company-logo
                                    [companyWebsite]="account?.thumbnail?.website"
                                    [companyLogoUrl]="account?.thumbnail?.logoUrl"
                                    [countryCode]="null | countryCode : account.currency"
                                    [type]="account.thumbnail?.icon"
                                    size="lg"
                                ></sb-company-logo>
                            </div>
                            <dt class="sb-account-name">
                                <a
                                    [routerLink]="['/', 'sb-grid', 'portfolio-summary']"
                                    [queryParams]="{
                                        accountIds:
                                            (account.type !== 'PORTFOLIO' &&
                                            account.data.length > 1
                                                ? account.data
                                                : groupBy.key !== 'id' && account.data
                                                ? account.data
                                                : [account]
                                            ) | accountIdConcat : 'id',
                                        legalEntityId:
                                            groupBy.key === 'legalEntity'
                                                ? account.data[0]?.legalEntity?.id
                                                : null,
                                        issuerId:
                                            groupBy.key === 'issuer'
                                                ? account.data[0]?.issuer?.id
                                                : null,
                                        tagId: groupBy.key === 'tags' ? account.id : null
                                    }"
                                >
                                    <span
                                        [matTooltip]="account.displayName || account.name"
                                        [innerHTML]="
                                            account.displayName || account.name
                                                | sanitize
                                                | highlight
                                                    : filterForm.controls.search.value
                                        "
                                    ></span>
                                </a>
                            </dt>
                            <dd class="sb-account-number">
                                <span
                                    *ngIf="
                                        account.number &&
                                        account.number !== account.displayName
                                    "
                                    [@fadeInOut]
                                    [innerHTML]="
                                        account.number + ''
                                            | sanitize
                                            | highlight : filterForm.controls.search.value
                                    "
                                ></span>
                                <sb-notification-badge
                                    *ngIf="
                                        viewCtrl.value !== 'detailed' &&
                                        account?.data?.length > 0
                                    "
                                    [tooltip]="
                                        groupBy.key === 'tags'
                                            ? 'Number of accounts tagged with ' +
                                              (account.displayName || account.name)
                                            : account.type === 'PORTFOLIO'
                                            ? 'Number of accounts in portfolio'
                                            : 'Number of accounts with ' +
                                              (account.displayName || account.name) +
                                              ' as ' +
                                              (groupBy.name | lowercase)
                                    "
                                    [numberOfNotifications]="account.data?.length"
                                ></sb-notification-badge>
                            </dd>
                            <dd class="sb-account-info invisible-scroll">
                                <span
                                    class="sb-account-legal-entity"
                                    *ngIf="(groupBy$ | async).key !== 'legalEntity'"
                                >
                                    <span
                                        class="badge badge-secondary badge-sm"
                                        *ngIf="
                                            account.legalEntity?.displayName as name;
                                            else listOfLegalEntities
                                        "
                                    >
                                        {{ account.legalEntity?.displayName }}
                                    </span>
                                    <ng-template #listOfLegalEntities>
                                        <span
                                            class="badge badge-secondary badge-sm"
                                            *ngFor="
                                                let legalEntities of account.data
                                                    | unique : 'legalEntity.id'
                                            "
                                        >
                                            {{ legalEntities.legalEntity?.displayName }}
                                        </span>
                                    </ng-template>
                                </span>
                                <span class="sb-account-type">
                                    <span
                                        class="badge badge-secondary badge-sm"
                                        *ngIf="
                                            account.data?.length <= 1;
                                            else listOfAccountTypes
                                        "
                                    >
                                        {{ account.type | translate }}
                                    </span>
                                    <ng-template #listOfAccountTypes>
                                        <span
                                            class="badge badge-secondary badge-sm"
                                            *ngFor="
                                                let accountTypes of account.data
                                                    | unique : 'type'
                                            "
                                        >
                                            {{ accountTypes.type | translate }}
                                        </span>
                                    </ng-template>
                                </span>
                                <span class="sb-account-currency">
                                    <span
                                        class="badge badge-secondary badge-sm"
                                        *ngIf="
                                            account.currency as currency;
                                            else listOfCurrencies
                                        "
                                    >
                                        {{ account.currency }}
                                    </span>
                                    <ng-template #listOfCurrencies>
                                        <span
                                            class="badge badge-secondary badge-sm"
                                            *ngFor="
                                                let currencies of account.data
                                                    | unique : 'account.currency'
                                            "
                                        >
                                            {{ currencies.currency }}
                                        </span>
                                    </ng-template>
                                </span>
                            </dd>
                            <dd class="sb-account-tags invisible-scroll">
                                <sb-badges
                                    outline="false"
                                    [badges]="account.tags"
                                    dismissible="true"
                                    showAddButton="true"
                                    size="sm"
                                    variant="info"
                                    (badgesChange)="updateTags($event, account)"
                                    [addIndicatorState]="addTagState$ | async"
                                    *ngIf="groupBy.key === 'id'"
                                ></sb-badges>
                                <span
                                    [@fadeInOut]
                                    *ngIf="groupBy.key !== 'id'"
                                    class="text-muted"
                                >
                                    Number of accounts: {{ account.data.length }}
                                </span>
                            </dd>
                            <dd
                                class="sb-account-balance"
                                *ngIf="!(loadingBalance$ | async); else loadingBalance"
                            >
                                <sb-animated-number
                                    [ccy]="
                                        (useBaseCurrency$ | async)
                                            ? (baseCurrency$ | async)
                                            : account.currency
                                    "
                                    [formatStyle]="
                                        useShortNumberFormat ? 'short' : 'code'
                                    "
                                    [maximumFractionDigits]="0"
                                    [useMonotypeFont]="false"
                                    [value]="account[balanceKey$ | async]"
                                ></sb-animated-number>
                            </dd>
                            <!-- prettier-ignore -->
                            <dd
                        class="sb-account-performance d-inline-flex align-items-center justify-content-end text-nowrap"
                        *ngIf="account?.performance[(period$ |async)?.name] as performance"
                        [class.text-positive]="performance > 0"
                        [class.text-negative]="performance < 0"
                    >
                        <tabler-icon
                            style="height: 18px; width: 18px"
                            name="circle-arrow-up"
                            [class.sb-transform-r90]="performance === 0"
                            [class.sb-transform-r45]="performance > 0"
                            [class.sb-transform-r135]="performance < 0"
                            class="me-1 tabler-fill-circle sb-transform-animate sb-icon-sm"
                        ></tabler-icon>

                                    <sb-animated-number
                                        class="font-weight-medium"
                                        [useMonotypeFont]="false"
                                        [maximumFractionDigits]="0"
                                        [value]="account[balanceKey$ | async] - account[balanceKey$ | async]/(1+performance)"
                                    ></sb-animated-number>
                         &nbsp;(<sb-animated-number
                                class="font-weight-medium"
                            [useMonotypeFont]="false"
                            formatStyle="percent"
                                [maximumFractionDigits]="1"
                                [minimumFractionDigits]="1"
                            [value]="performance"
                        ></sb-animated-number>)
                    </dd>
                            <span class="sb-account-actions mb-n2">
                                <button
                                    class="btn btn-link mx-n3 mt-n3 mb-n4 text-primary"
                                    [matMenuTriggerFor]="menu"
                                >
                                    <tabler-icon name="dots"></tabler-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <!-- prettier-ignore -->
                                    <a
                                        [routerLink]="[
                                            '/',
                                            'sb-grid',
                                            'portfolio-summary'
                                        ]"
                                        [queryParams]="{
                                            accountIds:
                                                (account.type !== 'PORTFOLIO' && account.data.length > 1 ?  account.data : groupBy.key !== 'id' && account.data ? account.data: [account])
                                                | accountIdConcat:'id',
                                            legalEntityId:
                                                groupBy.key === 'legalEntity'
                                                    ? account.data[0]?.legalEntity?.id
                                                    : null,
                                            issuerId:
                                                groupBy.key === 'issuer'
                                                    ? account.data[0]?.issuer?.id
                                                    : null,
                                            tagId:
                                                groupBy.key === 'tags'
                                                    ? account.id
                                                    : null
                                        }"
                                        class="d-flex align-items-center text-reset"
                                        mat-menu-item
                                    >
                                        <tabler-icon
                                            class="sb-icon-md me-2"
                                            name="arrow-right"
                                        ></tabler-icon>
                                        View <ng-container *ngIf="account.type !== 'PORTFOLIO';else portfolio">account<ng-container *ngIf="account.data?.length > 1">s</ng-container></ng-container>
                                        <ng-template #portfolio>portfolio</ng-template>
                                    </a>
                                    <a
                                        [routerLink]="['/', 'account-statement']"
                                        [queryParams]="{ accountId: account.id }"
                                        class="d-flex align-items-center text-reset"
                                        mat-menu-item
                                        *ngIf="
                                            groupBy.key === 'id' &&
                                            account.type !== 'PORTFOLIO'
                                        "
                                    >
                                        <tabler-icon
                                            class="sb-icon-md me-2"
                                            name="file-invoice"
                                        ></tabler-icon>
                                        View statement
                                    </a>
                                    <!--<a
                                        [routerLink]="[
                                            '',
                                            {
                                                outlets: {
                                                    dialog: [
                                                        'data-entry',
                                                        'accounting',
                                                        'add-rule'
                                                    ]
                                                }
                                            }
                                        ]"
                                        class="d-flex align-items-center text-reset"
                                        mat-menu-item
                                    >
                                        <tabler-icon
                                            class="sb-icon-md me-2"
                                            name="edit"
                                        ></tabler-icon>
                                        Edit account
                                    </a>-->
                                    <!--<button
                                type="button"
                                class="d-flex align-items-center"
                                mat-menu-item
                            >
                                <tabler-icon
                                    class="sb-icon-md me-2"
                                    name="refresh"
                                ></tabler-icon>
                                Recalculate
                            </button>
                            <button
                                type="button"
                                class="d-flex align-items-center"
                                mat-menu-item
                            >
                                <tabler-icon
                                    class="sb-icon-md me-2"
                                    name="refresh-alert"
                                ></tabler-icon>
                                Force recalculate
                            </button>
                            <button
                                type="button"
                                class="d-flex align-items-center"
                                mat-menu-item
                            >
                                <tabler-icon
                                    class="sb-icon-md me-2"
                                    name="file-spreadsheet"
                                ></tabler-icon>
                                Export as CSV (Beta)
                            </button>
                            <a
                                [routerLink]="[
                                    '',
                                    {
                                        outlets: {
                                            dialog: [
                                                'data-entry',
                                                'accounting',
                                                'add-rule'
                                            ]
                                        }
                                    }
                                ]"
                                class="d-flex align-items-center text-reset"
                                mat-menu-item
                            >
                                <tabler-icon
                                    class="sb-icon-md me-2"
                                    name="plus"
                                ></tabler-icon>
                                Add new mapping rule
                            </a>-->
                                </mat-menu>
                            </span>
                        </div>
                    </ng-container>
                </dl>
                <mat-paginator
                    class="mt-n1 mb-n3"
                    *ngIf="data.total > 8"
                    hidePageSize="true"
                    [length]="data.total"
                    pageSize="8"
                    (page)="onPageChange($event)"
                    aria-label="Select page"
                    [disabled]="hasPendingAnimation$ | async"
                ></mat-paginator>
            </ng-container>
        </div>
    </section>
    <div
        [class.opacity-0]="(ui.viewportSize$ | async) === 'xs'"
        class="backdrop"
        (click)="toggleShowFilters()"
        *ngIf="showFilters"
        [@fadeInOut]
    ></div>
</div>
<ng-template #loadingBalance>
    <span class="sb-account-balance text-nowrap text-muted" aria-busy="true">
        Loading balance...
    </span>
</ng-template>
<ng-template #noAccounts>
    <div
        *ngIf="isLoading$ | async"
        aria-busy="true"
        class="skeleton-loader skeleton-loader-table"
    >
        Loading accounts...
    </div>
    <div *ngIf="!(isLoading$ | async)" role="alert" class="info">
        <strong>No accounts found!</strong>
        &nbsp; Please try and
        <button
            class="btn link p-0"
            style="font-size: inherit"
            (click)="showFilters = true"
        >
            adjust filters
        </button>
        if applied or contact
        <a href="mailto:clientservice@swimbird.se">clientservice&#64;swimbird.se</a>
        if you need assistance.
    </div>
</ng-template>
